import { SearchTeam, SearchUserEnriched } from 'lib-search-types';

import { searchApi } from 'apis/search';
import {
  useMembersWithPresence,
  useOrganizationPresenceSubscription,
  usePresenceOverlaySync,
} from 'hooks/usePresenceCacheSync';
import { useCurrentUser } from 'utils/user';

type UsePresenceMembersResult = {
  members: SearchUserEnriched[];
  teams: readonly SearchTeam[];
  isLoading: boolean;
  isError: boolean;
};

export const usePresenceMembers = (): UsePresenceMembersResult => {
  useOrganizationPresenceSubscription();

  const { user } = useCurrentUser();

  const { allMembers, teams, membersLoading, membersFailed } =
    searchApi.useReadSearchUsersEnrichedQuery(
      {
        scope: 'users',
        filters: {
          strategy: 'all',
          filters: [
            {
              field: 'user_type',
              operator: 'is_one',
              values: [{ value: 'member' }],
            },
          ],
        },
        page: 0,
        pageSize: 1000,
        enrichmentSpec: ['teams'],
      },
      {
        selectFromResult: ({ data, isLoading, isError }) => {
          const allMembers =
            data?.data.results.map(({ result }) => result) ?? [];
          const me = allMembers.find(({ id }) => id === user.id);

          return {
            allMembers,
            teams: me?.teams?.filter((t) => !t.is_deactivated) ?? [],
            membersLoading: isLoading,
            membersFailed: isError,
          };
        },
      },
    );

  usePresenceOverlaySync();
  const members = useMembersWithPresence(allMembers);

  return {
    members,
    teams,
    isLoading: membersLoading,
    isError: membersFailed,
  };
};
